import { Link, Text } from '@sparemin/blockhead';
import React from 'react';
import { MEDIA_TOS_URL, PRIVACY_POLICY_URL, TOS_URL } from 'config/constants';

export interface LegalTextProps {}

const LegalText: React.FC<LegalTextProps> = () => (
  <Text align="left" variant="legal">
    By continuing you agree to our{' '}
    <Link
      href={TOS_URL}
      rel="noopener noreferrer"
      target="_blank"
      variant="inherit"
    >
      Terms of Service
    </Link>
    ,{' '}
    <Link
      href={MEDIA_TOS_URL}
      rel="noopener noreferrer"
      target="_blank"
      variant="inherit"
    >
      Media Use Terms
    </Link>{' '}
    and{' '}
    <Link
      href={PRIVACY_POLICY_URL}
      rel="noopener noreferrer"
      target="_blank"
      variant="inherit"
    >
      Privacy Policy
    </Link>
  </Text>
);

export default LegalText;
